var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgShareDark = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A202C",
    d: "M9 3.419v2.58h6c.553 0 1 .449 1 1.001v12c0 .552-.447 1-1 1H1c-.553 0-1-.448-1-1V7c0-.552.447-1 1-1h6V3.416L5.87 4.545c-.386.387-1.014.387-1.407-.007-.391-.39-.388-1.025-.007-1.407L7.298.29C7.49.097 7.742 0 7.995 0l.008.004c.254 0 .506.095.696.286L11.54 3.13c.387.387.387 1.015-.005 1.407-.391.391-1.027.388-1.409.007L9 3.419zM7 8V6H3c.552 0 1 .448 1 1s-.448 1-1 1h4zm2 0h5V6H9v2zM7 8H2v10h12V8H9v5.002c0 .551-.444.998-1 .998-.552 0-1-.448-1-.998V8zm7 0h-1c-.552 0-1-.448-1-1s.448-1 1-1h1v2z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShareDark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/share-dark.5b698be1.svg";
export { ForwardRef as ReactComponent };